export default __webpack_public_path__ + "static/media/Warcraft.26a90018.jpg";